var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.29113C1 8.29853 3.42543 10.7855 4.49899 11.739C4.65263 11.8755 4.73037 11.9445 4.845 11.9796C4.93426 12.0068 5.06562 12.0068 5.15488 11.9796C5.26972 11.9445 5.34692 11.8761 5.50114 11.7391C6.5747 10.7856 9 8.29881 9 5.29141C9 4.15329 8.57859 3.06165 7.82844 2.25688C7.07829 1.45211 6.06094 1 5.00007 1C3.9392 1 2.92173 1.45218 2.17158 2.25695C1.42143 3.06172 1 4.15302 1 5.29113Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.85716 4.7191C3.85716 5.40377 4.36884 5.9588 5.00002 5.9588C5.63121 5.9588 6.14289 5.40377 6.14289 4.7191C6.14289 4.03443 5.63121 3.4794 5.00002 3.4794C4.36884 3.4794 3.85716 4.03443 3.85716 4.7191Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.77776c099f3554b2d112ed1d59c6b1cd.svg";
export { ForwardRef as ReactComponent };